import { useMutation, useQueryClient } from '@tanstack/react-query';

import { SIMULATION_STATUS_KEY, STATUS_ACTIONS } from '../config';
import { passFundingStep } from '../services';
import { useSandboxUiContext } from './useSandboxUiContext';

type FundingPayload = {
  action: STATUS_ACTIONS;
  [key: string]: string | number;
};

export const useFundingStep = () => {
  const sandboxUiContext = useSandboxUiContext();
  const companyToken = sandboxUiContext?.companyToken;
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ action, ...args }: FundingPayload) => {
      if (!companyToken) throw new Error('Missing companyToken');

      await passFundingStep(companyToken, action, args);
    },
    onSuccess: async () => {
      if (!companyToken) throw new Error('Missing companyToken');

      await queryClient.invalidateQueries({ queryKey: [SIMULATION_STATUS_KEY] });
    },
  });
};
